<template>
  <div v-if="false" class="text-center" />
</template>

<script>
import { mapGetters } from 'vuex'
const PHONE_TABLE_SIZE = '(min-width: 769px)'
export default {
  computed: {
    ...mapGetters({
      isMobile: 'getIsMobileDensity',
    }),
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    setIsMobileDensity(value) {
      this.$store.commit('$_app/setIsMobileDensity', value)
    },
    setIsNavOpen(value) {
      this.$store.commit('$_app/setIsNavOpen', value)
    },
    handleResize() {
      const mq = window.matchMedia(PHONE_TABLE_SIZE)
      if (mq.matches) {
        this.setIsNavOpen(true)
        this.setIsMobileDensity(false)
      } else {
        this.setIsMobileDensity(true)
      }
    },
  },
}
</script>
